export const GET_INSIGHTS = 'GET_INSIGHTS';
export const GET_READINESS = 'GET_READINESS';
export const GET_JOURNAL = 'GET_JOURNAL';
export const GET_DATA_QUALITY = 'GET_DATA_QUALITY';
export const GET_HEART_RATE_ZONES = 'GET_HEART_RATE_ZONES';
export const GET_SESSION_HISTORY = 'GET_SESSION_HISTORY';
